import { render } from "./Relacion_ActoresRegistro.vue?vue&type=template&id=4c8e00b0"
import script from "./Relacion_ActoresRegistro.vue?vue&type=script&lang=js"
export * from "./Relacion_ActoresRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__